import { localeOption } from "primereact/api";
import { getLocale } from "../utilities/locale/locale";

const localeText = (key, options) => {
  let value;
  try {
    value = localeOption(key, getLocale());
  } catch (e) {
    return undefined;
  }
  if (typeof value === "function") {
    return options ? value(options) : value();
  }

  if (typeof value === "string" && options && typeof options === "object") {
    let result = value;
    Object.keys(options).forEach((k) => {
      const v = options[k];
      const re = new RegExp(`\\{${k}\\}`, "g");
      result = result.replace(re, String(v));
    });
    return result;
  }

  return value;
};

export default localeText;
